import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "SkillLevel"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", { d: "M22.5 22.5H16.5V3H22.5V22.5zM18 21H21V4.5H18V21zM15 22.5H9V9H15V22.5zM10.5 21H13.5V10.5H10.5V21zM7.5 22.5H1.5V13.5H7.5V22.5zM3 21H6V15H3V21z" }, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/SkillLevel.vue"]]);
